import { Link } from "react-router-dom";

const entries = [
  {
    to: "/movies",
    label: "伦理电影",
    english: "Ethics on Film",
    description: "两小时内的道德困境，一次完整的价值撕裂与重建。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20empty%20old%20movie%20theatre%20with%20deep%20navy%20velvet%20seats%20and%20a%20warm%20amber%20projector%20beam%20cutting%20through%20dust%2C%20atmospheric%20film%20still%20look%2C%20soft%20grain%2C%20no%20text&width=1000&height=620&seq=entry-movies&orientation=landscape",
    count: "7 部精选",
    icon: "ri-film-line",
  },
  {
    to: "/series",
    label: "伦理电视剧",
    english: "Long-form Ethics",
    description: "用十几集的时间，看一段关系如何缓慢地走向它的结局。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20warm%20lit%20living%20room%20window%20at%20dusk%20seen%20from%20outside%2C%20deep%20navy%20evening%20and%20amber%20lamplight%20inside%2C%20rain%20on%20the%20glass%2C%20quiet%20domestic%20atmosphere%2C%20soft%20film%20grain%2C%20no%20text&width=1000&height=620&seq=entry-series&orientation=landscape",
    count: "4 部精选",
    icon: "ri-tv-2-line",
  },
];

export default function QuickEntries() {
  return (
    <section className="w-full px-4 py-10 md:px-10 md:py-14">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
        {entries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group relative flex h-[220px] flex-col justify-end overflow-hidden rounded-lg bg-primary-900 p-5 md:h-[300px] md:p-7 cursor-pointer"
          >
            <img
              src={entry.image}
              alt={`${entry.label}分类入口`}
              title={`${entry.label} - 伦理视频`}
              className="absolute inset-0 h-full w-full object-cover object-center opacity-70 transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/95 via-primary-950/50 to-primary-950/10" />
            <div className="relative z-10">
              <span className="font-label text-[10px] uppercase tracking-[0.3em] text-accent-300">
                {entry.english}
              </span>
              <div className="mt-2 flex items-end justify-between gap-4">
                <div>
                  <h2 className="flex items-center gap-2 font-heading text-xl font-semibold text-background-50 md:text-2xl">
                    <i className={`${entry.icon} text-accent-400`} />
                    {entry.label}
                  </h2>
                  <p className="mt-2 max-w-sm text-xs leading-relaxed text-background-200 md:text-sm">
                    {entry.description}
                  </p>
                </div>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-background-50/40 text-background-50 transition-colors group-hover:border-accent-400 group-hover:bg-accent-500 group-hover:text-background-50">
                  <i className="ri-arrow-right-up-line text-lg" />
                </span>
              </div>
              <p className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-background-50/10 px-2.5 py-1 text-[11px] text-background-100 backdrop-blur-sm">
                <i className="ri-database-2-line" />
                {entry.count}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}